import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { ListItemIcon, MenuItem, ListItemText } from "@mui/material";
import { MenuInput } from "../../utils/MenuInput";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
function LoadFileMenuItem({ callback }) {
    return (_jsx(MenuInput, Object.assign({ handleChange: callback, multiple: true }, { children: _jsxs(MenuItem, Object.assign({ onClick: () => { }, dense: true }, { children: [_jsx(ListItemIcon, { children: _jsx(FolderOpenIcon, {}) }), _jsx(ListItemText, { children: "Open" })] }), "sidebar-load-files") }), "sidebar-load-files-wrap"));
}
export default LoadFileMenuItem;
